/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTiktok from 'base/components/standalone/Tiktok';

export const DynamicStandaloneTiktok = StandaloneTiktok;
export type DynamicStandaloneTiktokProps = PropsFromComponent<typeof StandaloneTiktok>;

export const DynamicStandaloneTiktokWith = (extras: DynamicStandaloneExtras): typeof StandaloneTiktok => {
    return function DynamicStandaloneTiktok(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Tiktok');
        return <StandaloneTiktok {...mergeProps({ options: { theme } }, props)} />;
    }
}